<template>
  <div>
    <div class="container-fluid">
      <nav-bar-component></nav-bar-component>
      <setup-menu-nav-component></setup-menu-nav-component>
    </div>
    <div class="container-fluid">
      
      <div class="row justify-content-center">
        
        <div class="col-md-10">
          <div class="container">
            <b-form @submit.stop.prevent="saveTemplate">
              <div class="form-group">
                <label for="templateNameInput">Template Name</label>
                <!--<input v-model="templateName" placeholder="" class="form-control" id="templateNameInput" @input="isSavable = true;">-->
                <b-form-input
                  id="templateNameInput"
                  name="templateNameInput"
                  v-model="templateName"
                  aria-describedby="template-name-live-feedback"
                  @input="setDirty"
                  required
                ></b-form-input>
              </div>
  
              <textarea-emoji-picker v-model="templateBody"  rows="3" :placeholder="messagePlaceholder" @typing="setDirty();updatePreview()"/>
              
              <h5>Buttons</h5>
              <b-container>
                <b-row v-if="showBtn1" class="button-rows">
                  <b-col>
                    <label>Button Label</label>
                    <b-form-input v-model="btn1.btn1Label" type="text" @input="setDirty"></b-form-input>                    
                  </b-col>
                  <b-col>
                    <label>URL</label>
                    <b-form-input v-model="btn1.btn1Url" :placeholder="urlPlaceholder" type="text" @input="setDirty();updatePreview()"></b-form-input>                    
                  </b-col>
                  <b-col>
                    <label>Display as</label>
                    <b-form-select v-model="btn1.btn1DisplayAs" :options="displayAsOptions" @change="setDirty"></b-form-select>
                  </b-col>
                  <b-col class="delete-col">
                    <b-button v-show="showBtn1 && !showBtn2" @click="deleteButton(1)" variant="link"><b-icon icon="trash" variant="danger"></b-icon></b-button>
                  </b-col>
                </b-row>
                <b-row v-if="showBtn2" class="button-rows">
                  <b-col>                    
                    <b-form-input v-model="btn2.btn2Label" type="text" @input="setDirty"></b-form-input>                    
                  </b-col>
                  <b-col>                    
                    <b-form-input v-model="btn2.btn2Url" :placeholder="urlPlaceholder" type="text" @input="setDirty();updatePreview()"></b-form-input>                    
                  </b-col>
                  <b-col>                    
                    <b-form-select v-model="btn2.btn2DisplayAs" :options="displayAsOptions" @change="setDirty"></b-form-select>
                  </b-col>
                  <b-col >
                    <b-button v-show="showBtn2 && !showBtn3" @click="deleteButton(2)" variant="link"><b-icon icon="trash" variant="danger"></b-icon></b-button>
                  </b-col>
                </b-row>
                <b-row v-if="showBtn3" class="button-rows">
                  <b-col>                    
                    <b-form-input v-model="btn3.btn3Label" type="text" @input="setDirty"></b-form-input>                    
                  </b-col>
                  <b-col>                    
                    <b-form-input v-model="btn3.btn3Url" :placeholder="urlPlaceholder" type="text" @input="setDirty();updatePreview()"></b-form-input>                    
                  </b-col>
                  <b-col>                    
                    <b-form-select v-model="btn3.btn3DisplayAs" :options="displayAsOptions" @change="setDirty"></b-form-select>
                  </b-col>
                  <b-col >
                    <b-button @click="deleteButton(3)" variant="link"><b-icon icon="trash" variant="danger"></b-icon></b-button>
                  </b-col>
                </b-row>
                <b-button @click="addButton" variant="link" v-show="!showBtn3">+ Add Button</b-button>
              </b-container>
              
              <div class="preview-test-area">
              <h5>Preview and Test</h5>
              <div class="row">
                <div class="col">  
                  <div class="form-group">
                    <label>Test Data</label>
                    <div class="row test-data-row" v-for="(cur, index) in dataPreviewList" v-bind:key="cur">
                      <div class="col">
                        <input readonly v-model="dataPreviewList[index]" class="form-control" />
                      </div>
                      <div class="col">
                        <input v-model="dataValueList[index]" class="form-control" @keyup="updateDataValues"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
              
                  <div class="form-group">
                    <label for="templatePreview">Preview</label>
                    <!--<textarea readonly class="form-control template-preview-box" id="templatePreview" rows="3" v-model="previewTextArea" ></textarea>-->
                    <b-card >
                      <b-card-text id="templatePreview" class="mergedBody">{{previewTextArea}}</b-card-text>
                      <b-button :href="btn1PreviewUrl" size="sm" :variant="btn1.btn1DisplayAs == 'Button' ? 'info' : 'link'" class="buttons-left raven-action-button1" v-show="showBtn1">
                        {{btn1.btn1Label}}
                      </b-button>
                      <b-button :href="btn2PreviewUrl" size="sm" :variant="btn2.btn2DisplayAs == 'Button' ? 'info' : 'link'" class="buttons-left raven-action-button2" v-show="showBtn2">
                        {{btn2.btn2Label}}
                      </b-button>
                      <b-button :href="btn3PreviewUrl" size="sm" :variant="btn3.btn3DisplayAs == 'Button' ? 'info' : 'link'" class="buttons-left raven-action-button3" v-show="showBtn3">
                        {{btn3.btn3Label}}
                      </b-button>
                      <template v-slot:footer >                                              
                        <small><timeago class="text-muted" id="timeago-component" :datetime="dateVal" :auto-update="60" v-b-tooltip.hover.right="dateVal"></timeago></small>
                      </template>
                    </b-card>
                  </div>
                </div>
              </div>

              <div class="button-area">
                <b-alert class="text-left"
                    :show="saveErrors"
                    variant="danger"
                  >{{saveErrorMessage}}</b-alert>
                <div class="buttons-left">
                  <div class="btn-group" role="group">
                  <button type="button" class="btn btn-outline-secondary" @click="cancel">Cancel</button>
                  </div>
                  <div class="btn-group" role="group">
                    <b-button type="submit" variant="primary" :disabled="!isSavable" :class="(isSavable ? '' : 'disabled')">Save changes</b-button>
                  </div>
                </div>
                <div class="buttons-right">
                  <div class="btn-group" role="group">
                  <button type="button" class="btn btn-outline-danger" v-on:click="deleteTemplate" v-show="isEditMode">Delete</button>
                  </div>
                </div>
              </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>     
  </div>
</template>

<script>
// @ is an alias to /src
// Your corresponding keys
import NavBarComponent from '@/components/NavBarComponent.vue'
import SetupMenuNavComponent from '@/components/SetupMenuNavComponent.vue'
import TextareaEmojiPicker from './TextareaEmojiPicker'

var _ = require('lodash');
var Parse = require('parse/node');
var moment = require('moment');
const emojiUnicode = require("emoji-unicode");
const toEmoji = require("emoji-name-map")
Parse.initialize(process.env.VUE_APP_PARSE_APP_ID, process.env.VUE_APP_PARSE_JS_KEY, process.env.VUE_APP_PARSE_MASTER_KEY);
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL;

export default {
  name: 'TemplateEditorComponent',
  components: {
    NavBarComponent,
    SetupMenuNavComponent,
    TextareaEmojiPicker
  },
  created() {

  },
  mounted: function () {
    
    this.fetchUserFields();
    //console.log('id url param = ' + this.$route.params.id);
    if (this.$route.params.id && this.$route.params.id != 'new') {
      this.templateId = this.$route.params.id;
      this.isEditMode = true;
      this.fetchTemplate();
    } else {
      this.isSavable = true;
    }
    
    _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
  },
  data: function () {
    return {
      companyId: "",
      templateName: "",
      templateBody: "",
      templateId : "",
      messagePlaceholder: "You can use variables with notation like this: {{first_name}}",
      urlPlaceholder: "{{urlVar}} OR http:// ",
      previewTextArea : "",
      dataPreviewList : [],
      dataValueList : [],
      templateDataObject : {},      
      btn1 : {},
      btn2 : {},
      btn3 : {},
      showBtn1 : false,
      showBtn2 : false,
      showBtn3 : false,
      btn1PreviewUrl : '',
      btn2PreviewUrl : '',
      btn3PreviewUrl : '',
      displayAsOptions : [
          { value: 'Button', text: 'Button' },
          { value: 'Link', text: 'Link' }
      ],
      isSavable : false,
      isEditMode : false,
      saveErrors : false,
      saveErrorMessage : '',
      dateVal: moment().format()
    }
  },
  methods: {
    fetchUserFields() {
      const query1 = new Parse.Query(Parse.User);
      query1.get(Parse.User.current().id).then((user) => {
        
        this.companyId = user.attributes.CompanyId.id;
      }, (error) => {
        console.error('Error while fetching user', error);
      });
    },
    fetchTemplate() {
      const Template = Parse.Object.extend("NotificationTemplate");
      const query = new Parse.Query(Template);
        query.equalTo("objectId", this.templateId );
        
        query.first().then((resultObject) => {
          this.templateName = resultObject.get("Name");
          this.templateBody = resultObject.get("MessageBody");
          
          this.setupButtons(resultObject);

          this.updatePreview();
        })
        
        
    },
    setupButtons(resultObject) {
      if (resultObject.get("Button1Label")) {
        this.btn1 = {
          btn1Label : resultObject.get("Button1Label"),
          btn1Url : resultObject.get("Button1Url"),
          btn1DisplayAs : resultObject.get("Button1DisplayAs")
        }            
      }
      this.showBtn1 = !(_.isEmpty(this.btn1));          
      if (resultObject.get("Button2Label")) {
        this.btn2 = {
          btn2Label : resultObject.get("Button2Label"),
          btn2Url : resultObject.get("Button2Url"),
          btn2DisplayAs : resultObject.get("Button2DisplayAs")
        }
      }
      this.showBtn2 = !(_.isEmpty(this.btn2));
      if (resultObject.get("Button3Label")) {
        this.btn3 = {
          btn3Label : resultObject.get("Button3Label"),
          btn3Url : resultObject.get("Button3Url"),
          btn3DisplayAs : resultObject.get("Button3DisplayAs")
        }
      }
      this.showBtn3 = !(_.isEmpty(this.btn3));
    },
    saveTemplate() {
      //TODO add more validation
      if (!this.validateForm()) return;

      var todo_acl = new Parse.ACL();
      todo_acl.setWriteAccess( Parse.User.current(), true);
      todo_acl.setPublicReadAccess( true);
      
      const Company = Parse.Object.extend('Company');
      var companyPointer = Company.createWithoutData(this.companyId);
      var templateToInsert = new Parse.Object("NotificationTemplate", {
          "objectId": this.templateId,
          "Name": this.templateName,
          "CompanyId": companyPointer,
          "MessageBody" : this.templateBody
        });
      if (this.showBtn1) {
        templateToInsert.set("Button1Label", this.btn1.btn1Label);
        templateToInsert.set("Button1Url", this.btn1.btn1Url);
        templateToInsert.set("Button1DisplayAs", this.btn1.btn1DisplayAs);
      }
      if (this.showBtn2) {
        templateToInsert.set("Button2Label", this.btn2.btn2Label);
        templateToInsert.set("Button2Url", this.btn2.btn2Url);
        templateToInsert.set("Button2DisplayAs", this.btn2.btn2DisplayAs);
      }
      if (this.showBtn3) {
        templateToInsert.set("Button3Label", this.btn3.btn3Label);
        templateToInsert.set("Button3Url", this.btn3.btn3Url);
        templateToInsert.set("Button3DisplayAs", this.btn3.btn3DisplayAs);
      }
      templateToInsert.setACL(todo_acl);
      templateToInsert.save()
        .then((result) => {
          console.log(result);
          this.$router.replace("/templates");
        })
        .catch((function (e) {
          this.saveErrorMessage = "Error saving template: " + e.message;
          this.saveErrors = true;
        }))
    },

    validateForm() {
      if (!this.templateName || this.templateName === 0) {
        this.saveErrorMessage = "Error saving template: " + 'Name is required.';
        this.saveErrors = true;
        return false;
      }
      if (this.showBtn1 && ((!this.btn1.btn1Label || this.btn1.btn1Label === 0) 
          || (!this.btn1.btn1Url || this.btn1.btn1Url === 0)
          || (!this.btn1.btn1DisplayAs || this.btn1.btn1DisplayAs === 0))) {
          this.saveErrorMessage = "Error saving template: " + 'Button values are required.';
          this.saveErrors = true;
          return false;
      }

      if (this.showBtn2 && ((!this.btn2.btn2Label || this.btn2.btn2Label === 0) 
          || (!this.btn2.btn2Url || this.btn2.btn2Url === 0)
          || (!this.btn2.btn2DisplayAs || this.btn2.btn2DisplayAs === 0))) {
          this.saveErrorMessage = "Error saving template: " + 'Button values are required.';
          this.saveErrors = true;
          return false;
      }

      if (this.showBtn3 && ((!this.btn3.btn3Label || this.btn3.btn3Label === 0) 
          || (!this.btn3.btn3Url || this.btn3.btn3Url === 0)
          || (!this.btn3.btn3DisplayAs || this.btn3.btn3DisplayAs === 0))) {
          this.saveErrorMessage = "Error saving template: " + 'Button values are required.';
          this.saveErrors = true;
          return false;
      }
      return true;
    },

    addButton() {
      if (!this.showBtn1) {
        this.showBtn1 = true;
        //this.btn1.btn1DisplayAs = 'Button';
      } else if (!this.showBtn2) {
        this.showBtn2 = true;
        //this.btn2.btn2DisplayAs = 'Button';
      } else {
        this.showBtn3 = true;
        //this.btn3.btn3DisplayAs = 'Button';
      }
      this.isSavable = true;
    },
    deleteButton(index) {
      if (index == 1) {
        this.btn1 = {};
        this.showBtn1 = false;
      } else if (index == 2) {
        this.btn2 = {};
        this.showBtn2 = false;
      } else {
        this.btn3 = {};
        this.showBtn3 = false;
      }
      this.isSavable = true;
    },
    cancel() {
      this.$router.replace("/templates");
    },
    updatePreview() {
      this.trimVariables();
      this.findVariables();
      try {
        let previewText = _.template(this.templateBody);
        console.log('template data obj = ' + JSON.stringify(this.templateDataObject));
        let origMessage = previewText(this.templateDataObject);

        // find emoji colons
        this.previewTextArea = this.emojiMerge(origMessage);
        this.templateBody = this.emojiMerge(this.templateBody);
        // Update button link urls
        if (this.showBtn1 && this.btn1 && this.btn1.btn1Url) {
          let previewText = _.template(this.btn1.btn1Url);
          this.btn1PreviewUrl = previewText(this.templateDataObject);
        }
        if (this.showBtn2 && this.btn2 && this.btn2.btn2Url) {
          let previewText = _.template(this.btn2.btn2Url);
          this.btn2PreviewUrl = previewText(this.templateDataObject);
        }
        if (this.showBtn3 && this.btn3 && this.btn3.btn3Url) {
          let previewText = _.template(this.btn3.btn3Url);
          this.btn3PreviewUrl = previewText(this.templateDataObject);
        }
      } catch(e) {
        console.log(e);
      }
    },
    updateDataValues() {
      var obj = {};
      for (let i = 0; i < this.dataPreviewList.length; i++) {
        let keyval = this.dataPreviewList[i].replace(/[{}]/g, '');
        obj[keyval] = this.dataValueList[i];
      }
      
      this.templateDataObject = obj;

      this.updatePreview();
    },
    findVariables() {
      let checkString = this.templateBody;

      //var dataVars = String(this.templateBody).match(/{{([\s\S]+?)}}/g);
      
      // also check the button urls for variables
      if (this.btn1 && this.btn1.btn1Url) {
        checkString += ' ' + this.btn1.btn1Url;
      }
      if (this.btn2 && this.btn2.btn2Url) {
        checkString += ' ' + this.btn2.btn2Url;
      }
      if (this.btn3 && this.btn3.btn3Url) {
        checkString += ' ' + this.btn3.btn3Url;
      }
      console.log('check string = ' + checkString);
      var dataVars = String(checkString).match(/{{([\S]+?)}}/g);
      console.log('vars = ' + dataVars);
      if (dataVars) {
        // remove dupes
        let varSet = new Set();
        dataVars.map(cur => varSet.add(cur));
        let foundArray = Array.from(varSet);
        this.dataPreviewList = foundArray;
      }
      
      if (this.dataPreviewList && this.dataValueList && this.dataPreviewList.length > this.dataValueList.length) {
        this.dataValueList.push('TestVariable');
        this.updateDataValues();
      } else if (this.dataPreviewList && this.dataValueList && this.dataPreviewList.length < this.dataValueList.length) {
        this.dataValueList.pop();
        this.updateDataValues();
      }
      
    },
    emojiMerge(originalMessage) {
      let mergedMessage = originalMessage;
      
      const re = /:[^:\s]*(?:::[^:\s]*)*:/gi;
      if (re.test(originalMessage)) {
        var emojiAlphas = [...originalMessage.match(re)];      
        if (emojiAlphas) {
          for (const cur of emojiAlphas) {
            if (toEmoji.get(cur)) {
              mergedMessage = originalMessage.replace(new RegExp(cur, 'g'), toEmoji.get(cur));      
            }
          }
        }
      }
      return mergedMessage;
    },
    deleteTemplate() {
      const Template = Parse.Object.extend('NotificationTemplate');
      const query = new Parse.Query(Template);
      // here you put the objectId that you want to delete
      
      query.get(this.templateId).then((object) => {
        object.destroy().then((response) => {
          console.log('Deleted Template', response);
          this.$router.replace("/templates");
        }, (error) => {
          console.error('Error while deleting Template', error);
        });
      });
    },
    setDirty() {
      this.isSavable = true;
    },
    trimVariables() {
      const regexSearch = /\s(?![^}]*(\{|$))/gm
      this.templateBody = this.templateBody.replace(regexSearch, '');
      
      if (this.btn1 && this.btn1.btn1Url) {
        this.btn1.btn1Url = this.btn1.btn1Url.replace(regexSearch, '');
      }
      if (this.btn2 && this.btn2.btn2Url) {
        this.btn2.btn2Url = this.btn2.btn2Url.replace(regexSearch, '');
      }
      if (this.btn3 && this.btn3.btn3Url) {
        this.btn3.btn3Url = this.btn3.btn3Url.replace(regexSearch, '');
      }
    }
  }
}
</script>

<style>
.btn-group {
  margin-right: 20px;
}
.buttons-left {
  display:inline-flex;
}
.buttons-right {
  display:inline-flex;
  float:right;
}
.test-data-row {
  margin-bottom:10px;
}
.template-preview-box {
  min-height:180px;
}
.mergedBody {
  white-space: pre-wrap;
}
.delete-col {
  margin-top:29px;  
}
.button-rows {
  margin-bottom:5px;
}
.raven-action-button1 {
  margin-right:5px;
}
.raven-action-button2 {
  margin-right:5px;
}
.raven-action-button3 {
  margin-right:5px;
}
.preview-test-area {
  margin-top:16px;
}
</style>